export default {
  landingPageNoProductsTitleNew: {
    id: 'landing_page_no_products_title_new',
    defaultMessage: 'Where are all the {category}?',
  },
  landingPageNoProductsFirstParagraph: {
    id: 'landing_page_no_products_first_paragraph',
    defaultMessage: 'Merlin’s beard! We don’t have any left in stock today.',
  },
  landingPageNoProductsSecondParagraph: {
    id: 'landing_page_no_products_second_paragraph',
    defaultMessage: 'Come by later, maybe they’ll be back by then!',
  },
}
